<app-container maxWidth="552px" class="flex flex-col justify-center items-center">
  <app-card [title]="'Przekaż do opłacenia'"
            [subtitle]="'Przekazuj wybrane opłaty do innych użytkowników Payka. Będę oni mogli je odroczyć. ' +
             'Informacje o dokonanej płatności zobaczysz na liście Twoich wydatków oraz wyślemy Ci wiadomość e-mail.'"
            [subtitleStyle]="{'text-align': 'justify'}"
            [formGroup]="form">
    <div content>
      <div class="flex flex-col">
        <mat-form-field appearance="outline" *ngIf="mode === liabilitiesDelegateMode.SINGLE">
          <mat-label>Przekazuj opłaty</mat-label>
          <mat-select
            [formControl]="form.sources"
            [compareWith]="compareObjects"
            appGtmFormEvent
            [eventField]="'selectOptions'"
            [eventForm]="formName">
            <mat-option *ngFor="let option of selectOptions" [value]="[option]">
              {{ option.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="mode === liabilitiesDelegateMode.MULTIPLE">
          <mat-label>Przekazuj opłaty</mat-label>
          <mat-select
            [formControl]="form.sources"
            multiple
            appGtmFormEvent
            [eventField]="'selectOptions'"
            [eventForm]="formName"
          >
            <mat-select-trigger>
              <div>{{ inputDisplayName }}</div>
            </mat-select-trigger>
            <mat-option *ngFor="let option of selectOptions" [value]="option">
              {{ option.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Adres e-mail odbiorcy</mat-label>
          <input
            matInput
            [formControl]="form.emailAddress"
            email
            appGtmFormEvent
            [eventField]="'email'"
            [eventForm]="formName"
          />

          <mat-error *ngIf="form.emailAddress.errors?.required"> Wpisz adres e-mail</mat-error>

          <mat-error *ngIf="form.emailAddress.errors?.email"> Wpisz prawidłowy adres e-mail</mat-error>

          <mat-error *ngFor="let error of errors"> {{ errorMessages[error] }}</mat-error>
        </mat-form-field>

        <mat-checkbox [formControl]="form.consent" class="checkbox-label--position-top-absolute">
          Zgadzam się na przekazanie na powyższy adres e-mail informacji dotyczących wskazanego wydatku.
        </mat-checkbox>
      </div>

      <mat-card-actions style="justify-content: center">
        <button [disabled]="form.invalid" color="primary" mat-raised-button (click)="save()">Zapisz</button>

        <button mat-button type="button" [routerLink]="cancelUrl">Anuluj</button>
      </mat-card-actions>
    </div>
  </app-card>
</app-container>
